import React from 'react';
import PropTypes from 'prop-types';
import { MenuLink as ReachMenuLink } from '@reach/menu-button';
import { MenuLink } from '../Menu';
import wrapForReachUI from './wrapForReachUI';

const PreparedMenuLink = wrapForReachUI(MenuLink);

const DropdownLink = ({ onSelect, ...props }: any) => {
  return (
    <ReachMenuLink
      as={PreparedMenuLink}
      {...props}
      onSelect={(...args: any[]) => {
        if (typeof onSelect === 'function') onSelect(...args);
      }}
    />
  );
};

(DropdownLink as any).propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
};

export default DropdownLink;
